<div class="generic-modal-root">

  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<form [formGroup]="form" *ngIf="form" >
  <div class="row-padding">
    <div class="row">
        <table>  
            <tr>         
              <td class="row-padding">
                <span>Client Type Name</span>
              </td>
              <td class="row-padding">
                <input
                  class="color-black"
                  autofocus
                  formControlName="clientTypeName"
                  type="text"/>
              </td>
            </tr>

            <tr>         
                <td class="row-padding">
                  <span>Client Type Code</span>
                </td>
                <td class="row-padding">
                  <input
                    class="color-black"
                    autofocus
                    formControlName="clientTypeCode"
                    type="text"/>
                </td>
              </tr>

            <tr>         
                <td class="row-padding">
                  <span>Organizations</span>
                </td>
                <td class="row-padding" >
                  <ul style="list-style-type: none;">
                  <li *ngFor="let org of organizations" >
                    <span>{{org.name}} </span>
                    <input 
                      id="shouldNotifyUserCreated" 
                      style="padding-left: 5px; vertical-align: middle; text-align: center;"
                      [checked]="selectedOrganizationIds.indexOf(org.organizationId) > -1"
                      type="checkbox"
                      (change)="toggleOrganizationSelect(org.organizationId);" >
                  </li>
                </ul>
                </td>
              </tr>
              
      </table>
      <table>
        <tr>
            <th style="padding: 0px 15px 0px 15px;">Product Name</th>
            <th style="padding: 0px 15px 0px 15px;">Price / Product</th>
        </tr>       
        <tr formArrayName="products" *ngFor="let product of products; let i = index">         
          <td class="row-padding">
            <span>{{product.name}}</span>
          </td>
          <td [formGroupName]="i" class="row-padding">
            <input
              [(ngModel)]="product.price"
              formControlName="price"
              class="color-black"
              autofocus
              min="0"
              step="0.01"
              type="number"/>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <span *ngIf="!form.valid" style="color: red;" class="m-form__help">
    Name, code, and product prices are required
  </span>
</form>

  <div style="height: 45px;">
    <button (click)="close()" class="btn btn-success" style="margin-left: 15px;float: right;margin-top: 10px;">Cancel</button>
    <button (click)="saveAndClose()" class="btn btn-success" style="margin-left: 15px;float: right;margin-top: 10px;">Save</button>
  </div>
</div>